export default __webpack_public_path__ + "static/media/menu_link_account_selected.87276ac7.svg";